import { render } from "./AddGroup.vue?vue&type=template&id=506dc625&scoped=true"
import script from "./AddGroup.vue?vue&type=script&lang=js"
export * from "./AddGroup.vue?vue&type=script&lang=js"

import "./AddGroup.vue?vue&type=style&index=0&id=506dc625&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506dc625"]])

export default __exports__